/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ContentTypeInterceptor } from './content-type-interceptor';
import { AuthorizationInterceptor } from './authorization-interceptor';
import { XFrameOptionsInterceptor } from './x-frame-options.interceptor';
import { XContentTypeOptionsInterceptor } from './x-content-type-options.interceptor';
import { strictTransportSecurityInterceptor } from './strict-transport-security.interceptor';
import { featurePolicyInterceptor } from './feature-Policy.interceptor';
import { referrerPolicyInterceptor } from './Referrer-Policy.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ContentTypeInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: XFrameOptionsInterceptor, multi:true },
  { provide: HTTP_INTERCEPTORS, useClass: XContentTypeOptionsInterceptor, multi:true },
  { provide: HTTP_INTERCEPTORS, useClass: strictTransportSecurityInterceptor, multi:true },
  { provide: HTTP_INTERCEPTORS, useClass: referrerPolicyInterceptor, multi:true },
  { provide: HTTP_INTERCEPTORS, useClass: featurePolicyInterceptor, multi:true }
];
